module.exports = __webpack_public_path__ + "static/img/inverted-outer-corner-quarter-pipe_256.b378074.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/inverted-outer-corner-quarter-pipe_256.png
// module id = Swk0
// module chunks = 0